import { FC, ReactElement } from 'react';

import { ExerciseEditView } from '../ExerciseEditView';

import { VoidFunctionNoArgs } from 'types';
import { Modal } from 'views/components';
import { IExercise } from 'views/components/Exercise/exercise.interface';

interface IExerciseDetailsProps {
  isOpen: boolean;
  handleClose: VoidFunctionNoArgs;
  currentExercise: IExercise | null;
  refetchExercises: () => Promise<void>;
  levelId: number | null | undefined;
  updateKnowledgeAreaDetails: VoidFunctionNoArgs;
}

const ExerciseDetails: FC<IExerciseDetailsProps> = (props): ReactElement | null => {
  const {
    isOpen,
    handleClose,
    currentExercise,
    refetchExercises,
    levelId,
    updateKnowledgeAreaDetails,
  } = props;

  return (
    <Modal
      modalTitle="knowledge-area.exercise.modal.title"
      isOpen={isOpen}
      handleClose={handleClose}
      size="wide"
    >
      <ExerciseEditView
        currentExercise={currentExercise}
        levelId={levelId}
        refetchExercises={refetchExercises}
        updateKnowledgeAreaDetails={updateKnowledgeAreaDetails}
        onClose={handleClose}
      />
    </Modal>
  );
};

export { ExerciseDetails };
